import React from 'react'

import './aboutus.css';
import {Navbar} from '../../components';
import {Footer} from '../../containers';

import aboutus_header from '../../assets/images/banner-Aboutus2-banner.webp';
import aboutus_header_safari from '../../assets/images/banner-Aboutus2-banner.png';

import logo from '../../assets/images/PaperCactusLogo2.webp';
import logo_safari from '../../assets/images/PaperCactusLogo2.png';

import pcg_photo1 from '../../assets/images/pcg_1.webp';
import pcg_photo1_safari from '../../assets/images/pcg_1.jpg';
import pcg_photo2 from '../../assets/images/pcg_2.webp';
import pcg_photo2_safari from '../../assets/images/pcg_2.jpg';

import staff_leo from '../../assets/images/BustLeo.png';
import staff_jacko from '../../assets/images/BustJacko.png';
import staff_chris from '../../assets/images/BustChris.png';
import staff_john from '../../assets/images/BustJohn.png';
import staff_zen from '../../assets/images/bustZen.png';
import staff_sapph from '../../assets/images/BustSapph.png';
import staff_andrew from '../../assets/images/BustAndrew.png';


const Aboutus = () => {
  return (
    <div className='AboutUs '>  
              <Navbar navbarstyle="papercactus__navbar" />
        <div className='page__header'>
          <div className='page__header-title'>
              <div className='page__general__divider'></div>
              <h1 style={{marginBottom: '-10px'}}>About Us</h1>
              <p style={{fontSize:'1.6rem'}}>Paper Cactus Games</p>
          </div>
            <picture>
              <source srcSet={aboutus_header} type='image/webp' />
              <source srcSet={aboutus_header_safari} type='image/png'/>
              <img className="papercactus__page-image" src={aboutus_header} alt="aboutus-header"/>
            </picture>
        </div>
        <div className="aboutus__background__container">
          <div className='aboutus__black__divider'></div>
          <div className='aboutus__general__container'>
            <div className='aboutus__general section__aboutusgeneral__padding'>
              <picture>
                <source srcSet={logo} type='image/webp'/>
                <source srcSet={logo_safari} type='image/png'/>
                <img className="papercactus__aboutus-general-image" src={logo} alt="pc_logo"/>
              </picture>
                <div className='aboutus__general__text'>
                  <div className='aboutus__general__text-title'>
                    <div className='page__general__divider'></div>
                    <h1>About Paper Cactus Games</h1>
                  </div>
                    <p>Paper Cactus Games is an up-and-coming Australian based Indie Video Game Company. Paper Cactus Games aims to be a long term predominantly game studio based in Adelaide, Australia; with a focus on 2.5D games.<br/> <br/>We are developing innovative and engaging gameplay with a focus on the rogue-like video game genre. 
                    In the future we will be expanding our team size and become a permanent fixture in the Game Developer space.
                    <br/><br/>
                    Contact us: <a className='aboutus__contact-link' href='mailto:contact@papercactusgames.com'>contact@papercactusgames.com</a>
                    </p>
                </div>
            </div>
              <div className='aboutus__general__photos'>
                <div className='aboutus__photos-container'>
                  <picture id='picture1'>
                    <source srcSet={pcg_photo1} type='image/webp'/>
                    <source srcSet={pcg_photo1_safari} type='image/png'/>
                    <img className="papercactus__aboutus-general-image" alt="pc_logo"/>
                  </picture>
                  <picture>
                    <source srcSet={pcg_photo2} type='image/webp'/>
                    <source srcSet={pcg_photo2_safari} type='image/png'/>
                    <img className="papercactus__aboutus-general-image" alt="pc_logo"/>
                  </picture>
                </div> 
                <p id="aboutus__general__smalltext">Photos by Naomi Jellicoe</p>
              </div>
              
          </div>
          <div className='aboutus__staff-container'>
            <div className='aboutus__staff__text '>
                <div className='page__general__divider'></div>
                <h1>Team</h1>
            </div>
            <div className='aboutus__staff'>
              <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_leo} alt="staff-bust-leo"/>
                  <div id='staff_info'>
                    <h3>Leo Cheung</h3>
                    <p>Director</p>
                    <p>Lead Artist</p>
                    <a href='https://x.com/BlueTwoDays' target="_blank" rel="noreferrer"><i class="fa-brands fa-square-x-twitter"></i> bluetwodays </a>
                  </div>
                </div>
                <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#5d8758'}}/>
              </div>  
              <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_jacko} alt="staff-bust-jacko"/>
                  <div id='staff_info'>
                    <h3>Jackson Michael</h3>
                    <p>Lead Programer</p>
                    <p>Game Designer</p>
                  </div>
                </div>
                <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#87a384'}}/>
              </div>  
              <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_sapph} alt="staff-bust-sapph"/>
                  <div id='staff_info'>
                    <h3>Sapphire Van Veen</h3>
                    <p>Lead Designer</p>
                    <p>Game Designer</p>
                    <a href='https://x.com/Sapphirris' target="_blank" rel="noreferrer"><i className="fa-brands fa-square-x-twitter"></i> Sapphirris</a>
                  </div>
                </div>
                <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#438a4b'}}/>
              </div>  
            </div>
            <div className='aboutus__staff'>
            <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_zen} alt="staff-bust-zen"/>
                  <div id='staff_info'>
                    <h3>Zenners</h3>
                    <p>Narrative Writer</p>
                    <a href='https://x.com/ZenFehr' target="_blank" rel="noreferrer"><i className="fa-brands fa-square-x-twitter"></i> ZenFehr</a>
                  </div>
                </div>
              <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#438a72'}}/>
            </div>  
            <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_chris} alt="staff-bust-chris"/>
                  <div id='staff_info'>
                    <h3>Chris Hill</h3>
                    <p>Environmental Design</p>
                  </div>
                </div>
              <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#85a188'}}/>
            </div>
            <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_john} alt="staff-bust-john"/>
                  <div id='staff_info'>
                    <h3>John Oestmann</h3>
                    <p>Composer</p>
                    <a href='https://www.youtube.com/@johnoestmann-music' target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube"></i>johnoestmann-music</a>
                  </div>
                </div>
              <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#37523a'}}/>
            </div>  

            <div className='aboutus__staff__column'>
                <div className='aboutus__staff__card'>
                  <img src={staff_andrew} alt="staff-bust-andrew"/>
                  <div id='staff_info'>
                    <h3>Andrew Farmer</h3>
                    <p>Website Developer</p>
                    <a href='https://x.com/aclfarmer' target="_blank" rel="noreferrer"><i className="fa-brands fa-square-x-twitter"></i> aclfarmer</a>
                  </div>
                </div>
              <div className='aboutus__staff__column_back-card' style={{backgroundColor:'#608a7d'}}/>
            </div>  
          </div>
        </div>
      </div>
        <Footer />
    </div>

  )
}

export default Aboutus